import PropTypes from "prop-types";
import React, { PureComponent } from "react";

export default class MemberSavings extends PureComponent {
  static propTypes = {
    membership: PropTypes.object.isRequired,
    me: PropTypes.object.isRequired,
    showCta: PropTypes.bool,
    registrationMembershipType: PropTypes.string.isRequired,
    headerText: PropTypes.string.isRequired
  };

  _membershipCtaHeader = () => {
    let text = "";
    if (this._isNonMember()) {
      text = "Join Today and Save!";
    } else {
      text = "Renew Now to Remain an AANP member!";
    }

    return <h1>{text}</h1>;
  };

  _membershipCtaText = () => {
    if (this._isNonMember()) {
      return (
        <div>
          <p>
            By joining AANP, not only can you access numerous member benefits,
            but you also gain exclusive rates on conference
            registration.&nbsp;&nbsp;In fact, AANP members save enough on
            conference registration to pay for their membership fees!
          </p>
        </div>
      );
    } else {
      return (
        <div>
          <p>
            Your AANP membership is about to expire. 
            Renew today to continue accessing the member benefits and savings you already enjoy!
          </p>
        </div>
      );
    }
  };

  _isNonMember = () => {
    const { membershipStatus } = this.props.me;
    return (
      (membershipStatus === 0 || membershipStatus === 3) &&
      !this.props.me.person.isMember
    );
  };

  render() {
    const { membership } = this.props;
    return (
      <div className="member-savings">
        {this.props.showCta ? (
          <div className="mb-2">
            {this._membershipCtaHeader()}
            {this._membershipCtaText()}
          </div>
        ) : (
          <h1>{this.props.headerText}</h1>
        )}
        {this._isNonMember() && (
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <div className="row">
                <div className="col-lg-6 text-center text-vertical-center">
                  <div>Cost of {membership.memberType}ship:</div>
                  <div className="mt-1">
                    ${membership.membershipFee.toFixed(2)}
                  </div>
                </div>
                {false && (
                  <div className="col-lg-2 text-center plus-sign text-vertical-center">
                    +
                  </div>
                )}
                <div className="col-lg-6 text-center text-vertical-center">
                  <div>Cost of Conference for AANP Members:</div>
                  <div className="mt-1">
                    ${membership.memberConferencePrice.toFixed(2)}
                  </div>
                </div>
              </div>
              <div className="row justify-content-center mt-4">
                <div className="col-lg-9 text-center text-vertical-center">
                  Bundled Membership + Conference Registration: $
                  {membership.memberTotal.toFixed(2)}
                </div>
              </div>
              <div className="row justify-content-center mt-1">
                <div className="col-lg-9 text-center text-vertical-center">
                  Cost of Conference Only for Nonmembers: $
                  {membership.nonMemberPrice.toFixed(2)}
                </div>
              </div>
              <div className="row justify-content-center mt-1">
                <div className="col-lg-9 text-center text-vertical-center">
                  An AANP Membership Will Save You:{" "}
                  <span className="text-savings">
                    ${membership.savings.toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
